import React, { useEffect } from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import EducationYouthServicesDetails from '../mendepartmentdetails/EducationYouthServices'


function EducationYouthServices() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Education || State of GTS";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            // subtitle="home"
            // title="Education Youth Services"
            subtitledown="Department of Education"
           />
            <EducationYouthServicesDetails/>
        </div>
    </>
  )
}

export default EducationYouthServices